import Heading from 'components/global/Heading'
import Bilboard from 'assets/images/bilboard.png';
import Bilboard2 from 'assets/images/bilboard2.png';
import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay, Pagination , Navigation } from "swiper";

const data = [ 
    "https://ichef.bbci.co.uk/news/976/cpsprodpb/1BBE/production/_126620170_gettyimages-1239665326.jpg" , 
    'https://www.bmediagroup.com/news/wp-content/uploads/2020/12/how-much-does-a-billboard-cost-social.jpg' , 
    'https://graphicsfamily.com/wp-content/uploads/edd/2020/06/Free-Restaurant-Billboard-Advertising-Template-scaled.jpg' , 
    'https://civicoutdoor.com.au/wp-content/uploads/Untitled-design-28.png' ,
    "https://i.ytimg.com/vi/kVwLQh4LRWw/maxresdefault.jpg"
]

const PlaceBased = () => {


    return (
        <div className=' h-full py-20'>
            <Heading
            title='Place Based'
            subTitle='Reach specific audiences in venues with high dwell times'
            />
            <div className=''>
                <Swiper
                    slidesPerView={3}
                    spaceBetween={30}
                    centeredSlides={true}
                    // centeredSlidesBounds={true}
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    navigation={true}
                    speed={500}
                    loop={true}
                    modules={[Pagination , Autoplay , Navigation]}
                    className="centered-swiper"
                    breakpoints={{
                        650 : {
                            slidesPerView : 3
                        } ,
                        200 : {
                            slidesPerView : 1 
                        }
                    }}
                >
                    {
                        data?.map((item,i) => (
                            <SwiperSlide 
                            key={i}
                            >
                                <div className='relative'>
                                    <img 
                                    src={item} 
                                    alt="" 
                                    className='object-cover rounded-lg'
                                    />
                                    <div className='slide-text absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[#dbdbdb77] w-[80%] py-2 lg:px-12 px-2 rounded-md text-center'>
                                        <h3>Bar/Restaurant Jukebox</h3>
                                        <div className='flex justify-center items-center gap-4 mt-1'>
                                            <p>8,006 screens</p>
                                            <p>21.8b impressions/month</p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </div>
    )
}

export default PlaceBased